import Vue from 'vue'

const key = 'i-admin-token'

export default {
  domain: window.NEWSLETTER_SERVER || 'http://localhost:8010',
  user: null,
  token: null,
  login (credentials) {
    const url = this.getUrl('login')
    return Vue.http.post(url, credentials)
  },
  getUrl (url) {
    return this.domain + '/' + url
  },
  changePassword (data) {
    return Vue.http.post('my/change-password', data)
  },
  clearToken () {
    this.token = null
    this.saveToken(this.token)
  },
  my () {
    const url = this.getUrl('my')
    return Vue.http.get(url)
  },
  getTokenFromStorage () {
    this.token = localStorage.getItem(key)
    return this.token
  },
  saveToken (token) {
    localStorage.setItem(key, token)
    this.setTokenForAllRequests(token)
  },
  setTokenForAllRequests (token) {
    Vue.http.options.headers.Authorization = 'Bearer ' + token
  },
  setDefaultHeaders () {
    Vue.http.options.root = this.domain
    if (!Vue.http.options.headers) {
      Vue.http.options.headers = {}
    }
    Vue.http.options.headers['Accept'] = 'application/json, text/plain, */*'
  },
  setInterceptors (router) {
    Vue.http.interceptors.push((request, next) => {
      // modify request
      // console.log(request);
      // continue to next interceptor
      next(response => {
        // modify response
        // response.body = '...';
        // console.log(response);
        if (response.status === 401) {
          router.push({
            name: 'login'
          })
        }
      })
    })
  },
  setUser (user) {
    this.user = user
  },
  getUser () {
    return this.user
  }
}



// WEBPACK FOOTER //
// ./src/services/Auth.js